import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatDividerModule } from "@angular/material/divider";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { MatCommonModule } from "@obg/mat.ui.common";
import { MatGlobalModule } from "@obg/mat.ui.global";
import { RouterModule } from "@obg/ngx.router";
import { CoreUiModule } from "@obg/ngx.ui.core";

import { LanguageSelectorMenuComponent } from "./language-selector-menu.component";
import { LanguageSelectorContainer } from "./language-selector.container";

@NgModule({
	imports: [
		MatCommonModule,
		MatGlobalModule,
		MatButtonModule,
		MatTooltipModule,
		MatMenuModule,
		MatDividerModule,
		CoreUiModule,
		RouterModule,
		CommonModule,
	],
	exports: [LanguageSelectorContainer, LanguageSelectorMenuComponent],
	declarations: [LanguageSelectorContainer, LanguageSelectorMenuComponent],
})
export class LanguageSelectorModule {}
